// extracted by mini-css-extract-plugin
export default {"tabs_outer":"styles_tabs_outer__iqKXZ","tabs_inner":"styles_tabs_inner__NhQYH","tab":"styles_tab__zajVI","active":"styles_active__+EStm"};